import KunLoading52 from './src/index'

KunLoading52.install = function (Vue) {
	Vue.component(KunLoading52.name, KunLoading52);
}

export default KunLoading52;
